var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBingChannel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 620,
    viewBox: "0 0 449 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 27.824C25.0001 26.4449 26.363 25.4796 27.6639 25.9373L137.57 64.608C138.37 64.8897 138.906 65.6459 138.906 66.4946V462.309C138.906 463.848 140.571 464.81 141.904 464.042L296.08 375.184C297.48 374.377 297.395 372.328 295.932 371.641L221.496 336.679C221.038 336.464 220.679 336.084 220.49 335.615L172.776 216.964C172.135 215.369 173.672 213.761 175.295 214.331L422.663 301.176C423.464 301.458 424 302.214 424 303.063V429.542C424 430.257 423.618 430.918 422.999 431.275L139.994 594.434C139.385 594.785 138.637 594.791 138.023 594.449L26.0449 532.106C25.4109 531.753 25.0178 531.084 25.0178 530.358L25.0001 27.824Z",
    stroke: "currentColor",
    strokeWidth: 50
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBingChannel);
export default __webpack_public_path__ + "static/media/bing_channel.7940d161f1964b0590d7f008d5f06f25.svg";
export { ForwardRef as ReactComponent };